import { BlurEvent, ChangeEvent, DataSourceAction, DataSourceExecutionEvent, LookupModelSearchEvent, LookupModelSelectionEvent, TableRowDisplayEvent, Textbox, ClickEvent, Button, Layout } from "@mcleod/components";
import { AutogenLayoutARControl } from "./autogen/AutogenLayoutARControl"
import { McLeodClassicIntegration, Navigation } from "@mcleod/core";

export class ARControl extends AutogenLayoutARControl {
    private _selectedCompany: string;
    sourceARControlOnExecution(event: DataSourceExecutionEvent) {
        this.setPercentageFields(this.mainDataSource.activeRow.get("accrue_nonbroker_expense") === "Y");
        this.setIntercompanyTable(this.mainDataSource.activeRow.get("is_intercompany") === "Y");
        this.enableTabs();
        if (event.getAction() === DataSourceAction.UPDATE) {
            Navigation.reloadCurrentPage(true);
        }
    }

    setPercentageFields(isChecked: boolean) {
        if (isChecked) {
            this.textboxCompanyAccrualPercentage.enabled = true;
            this.textboxOwnerAccrualPercentage.enabled = true;
            this.textboxCompanyAccrualPercentage.required = true;
            this.textboxOwnerAccrualPercentage.required = true;
        } else {
            this.textboxCompanyAccrualPercentage.enabled = false;
            this.textboxOwnerAccrualPercentage.enabled = false;
            this.textboxCompanyAccrualPercentage.required = false;
            this.textboxOwnerAccrualPercentage.required = false;
        }
    }

    setIntercompanyTable(isChecked: boolean) {
        this.tableIntercompany.visible = isChecked;
    }

    switchIntercompanyOnChange(event: ChangeEvent) {
        this.setIntercompanyTable(event.newValue);
    }

    switchAccrueExpenseOnChange(event: ChangeEvent) {
        this.setPercentageFields(event.newValue);
    }

    textboxIntercompanyLiabilityBeforeLookupModelSearch(event) {
        event.filter.ic_type = "P || B";
    }

    textboxIntercompanyAssetBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.ic_type = "R || B";
        event.filter.company_override = this._selectedCompany || null;
    }

    textboxCompanyCodeOnLookupModelSelection(event) {
        event.filter.id = this.mainDataSource.activeRow.get("company_id");
    }

    textboxCompanyCodeToOnLookupModelSelection(event) {
        event.filter.id = `!${this.mainDataSource.activeRow.get("company_id")}`;
    }

    textboxCompanyCodeAfterLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection) {
            this._selectedCompany = event.selection ? event.selection.get("id") : null;
        }
    }

    textboxTonuOtherChargeCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_tonu = "Y";
    }

    enableTabs() {
        const isLogixLicensed = this.mainDataSource.activeRow.get("is_logix_licensed");
        if (isLogixLicensed) {
            const isPaperWorkLicensed = this.mainDataSource.activeRow.get("is_paperwork_licensed");
            this.tabLogixSolutions.visible = true;
            this.tabPaperwork.visible = isPaperWorkLicensed;
        } else {
            this.tabLogixSolutions.visible = false;
        }
        const isPasswordLicensed = this.mainDataSource.activeRow.get("is_password_licensed");
        this.tabReceiptAdjustment.visible = isPasswordLicensed;
        if(!this.mainDataSource.activeRow.get("has_multiple_companies")) {
            this.tabIntercompany.visible = false;
        }
    }

    intercompanyTableOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const textbox = tableRow.findComponentById("textboxIcAssetAcct") as Textbox;
        textbox.quickInfoOverrideSearchMethod = async (layout: Layout, keyValue: any) => {
            const body = {
                search: keyValue,
                company_override: modelRow.get("company_id_due_to")
            };
            await layout.mainDataSource?.search(body);
        };
        const textboxLiability = tableRow.findComponentById("textboxIcLiabilityAcct") as Textbox;
        textboxLiability.quickInfoOverrideSearchMethod = async (layout: Layout, keyValue: any) => {
            const body = {
                search: keyValue,
                company_override: modelRow.get("company_id_due_from")
            };
            await layout.mainDataSource?.search(body);
        };
    }

    textboxBillTemplateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = "F";
        event.filter.template_number = ">0";
    }

    textboxSummaryTemplateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = "S";
        event.filter.template_number = ">0";
    }

    textboxMiscBillTemplateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = "M";
        event.filter.template_number = ">0";
    }

    textboxCustStmtTemplateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = "C";
        event.filter.template_number = ">0";
    }

    textboxInvoiceDueTemplateBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = "X";
        event.filter.template_number = ">0";
    }

    buttonDocumentDesignerOnClick(event: ClickEvent) {
        const button = event.target as Button;
        const fieldName = button.field.slice(2);
        const documentType = button.field.slice(0, 1);
        const templateNumber = this.activeRow?.get(fieldName) as string;
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.drs.EntryReportTemplate",
            `<ext> search report_template.template_number='${templateNumber}' and report_template.document_type='${documentType}'`);
    }

    onBlurPeriod(event: BlurEvent) {
        const component = event.target as Textbox;
        const value: string = component.text;
        const field: string = component.field;
        if (value) {
            if (Number(value) > 0) {
                this.mainDataSource.activeRow.set(`${field}_desc`, "Over " + value);
            } else {
                this.mainDataSource.activeRow.set(`${field}_desc`, "");
            }
        } else {
            this.mainDataSource.activeRow.set(`${field}_desc`, "");
        }
    }
}
